import type { Resource } from '../../';
export const general_errors_renderAlerts_componentStack: Resource = {"default":"Component Stack"};
